var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 42C33.0457 42 42 33.0457 42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22C2 33.0457 10.9543 42 22 42Z",
  fill: "#222222"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 36,
  height: 36
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0002 39.8951C31.8832 39.8951 39.8949 31.8833 39.8949 22.0003C39.8949 12.1173 31.8832 4.10559 22.0002 4.10559C12.1172 4.10559 4.10547 12.1173 4.10547 22.0003C4.10547 31.8833 12.1172 39.8951 22.0002 39.8951Z",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0002 39.8949C31.8832 39.8949 39.8949 31.8832 39.8949 22.0002C39.8949 12.1172 31.8832 4.10547 22.0002 4.10547C12.1172 4.10547 4.10547 12.1172 4.10547 22.0002C4.10547 31.8832 12.1172 39.8949 22.0002 39.8949Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.7283 25.5027C38.0396 25.5027 36.665 24.1281 36.665 22.4394C36.665 20.7507 38.0396 19.3761 39.7283 19.3761C40.2563 19.3761 40.7494 19.5114 41.1857 19.747C41.0636 18.9965 40.8977 18.259 40.6883 17.539C40.3785 17.4779 40.0555 17.443 39.7283 17.443C37.9043 17.443 36.3028 18.4292 35.4301 19.8954C35.4257 19.8954 35.4214 19.8954 35.4214 19.8954C35.4214 19.8954 34.0381 22.1383 31.673 25.4939C31.673 25.4939 33.9246 19.6423 36.8046 15.7718C36.8046 15.7718 36.3028 14.6896 35.0374 14.3448C35.0374 14.3448 30.3028 18.8219 26.873 24.6648C26.873 24.6648 28.0294 21.5492 30.9094 17.3601C30.9094 17.3601 30.3945 16.2823 29.1377 15.9288C29.1377 15.9288 26.3843 18.4118 22.9414 23.3732C22.9414 23.3732 24.1676 21.0125 25.4679 18.9223C25.4679 18.9223 24.8177 17.7528 23.6876 17.4867C23.6876 17.4867 22.9806 18.2634 21.6628 21.0081C21.6628 21.0081 19.1145 24.4292 17.2206 26.4627C17.2206 26.4627 17.7268 23.6481 21.6366 17.4474C21.6366 17.4474 21.1566 16.3914 19.8563 16.0205C19.8563 16.0205 16.2476 20.1616 12.7261 25.3936C12.7261 25.3936 14.5326 20.6939 16.9021 17.0328C16.9021 17.0328 16.1603 15.7892 15.1348 15.6016C15.1348 15.6016 12.8439 18.3725 10.6359 21.5405C10.2083 19.2147 8.1661 17.4474 5.72246 17.4474C5.39519 17.4474 5.07228 17.4823 4.76246 17.5434C4.55301 18.2634 4.38719 19.0008 4.26501 19.7514C4.69701 19.5158 5.19446 19.3805 5.72246 19.3805C7.41119 19.3805 8.78573 20.755 8.78573 22.4438C8.78573 24.1325 7.41119 25.507 5.72246 25.507C5.15955 25.507 4.63155 25.3499 4.17773 25.0838C4.27373 25.8387 4.40901 26.5805 4.59228 27.3048C4.95883 27.3878 5.3341 27.4401 5.72683 27.4401C7.5421 27.4401 9.13919 26.4627 10.0119 25.0096C10.4788 24.2939 11.7006 22.4219 12.2985 21.4968C11.2381 23.7921 10.3086 26.1092 9.13919 29.3339C9.13919 29.3339 9.71519 30.4598 10.8977 30.7652C10.8977 30.7652 15.0345 24.0627 17.0156 22.0685C17.0156 22.0685 15.9683 24.2459 15.0214 27.2568C15.0214 27.2568 15.545 28.3696 16.7799 28.6968C16.7799 28.6968 18.2636 27.3572 20.3101 24.5688L18.3334 29.6918C18.3334 29.6918 18.9966 30.9136 20.0788 31.123C20.0788 31.123 24.2592 23.251 27.0126 20.2532C27.0126 20.2532 24.9574 24.6736 24.4119 27.0038C24.4119 27.0038 24.7697 27.9943 26.1836 28.4394C26.1836 28.4394 29.7574 22.3347 32.4846 19.4808C32.4846 19.4808 29.9625 24.4379 29.3341 26.8379C29.3341 26.8379 29.7574 27.8765 31.0926 28.291C31.0926 28.291 32.4977 26.6765 34.8061 23.3121C35.2163 25.6554 37.2672 27.4445 39.7283 27.4445C40.1166 27.4445 40.4963 27.3965 40.8585 27.3092C41.0417 26.5848 41.177 25.843 41.273 25.0881C40.8192 25.3456 40.2912 25.5027 39.7283 25.5027Z",
  fill: "#1E1A34"
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 42C33.0457 42 42 33.0457 42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22C2 33.0457 10.9543 42 22 42Z",
  fill: "#222222"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 36,
  height: 36
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0002 39.8951C31.8832 39.8951 39.8949 31.8833 39.8949 22.0003C39.8949 12.1173 31.8832 4.10559 22.0002 4.10559C12.1172 4.10559 4.10547 12.1173 4.10547 22.0003C4.10547 31.8833 12.1172 39.8951 22.0002 39.8951Z",
  fill: "white"
}));

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0002 39.8949C31.8832 39.8949 39.8949 31.8832 39.8949 22.0002C39.8949 12.1172 31.8832 4.10547 22.0002 4.10547C12.1172 4.10547 4.10547 12.1172 4.10547 22.0002C4.10547 31.8832 12.1172 39.8949 22.0002 39.8949Z",
  fill: "white"
}));

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M35.6012 17.6737C34.1404 17.6737 32.86 18.4792 32.1621 19.6789C32.1577 19.6789 32.156 19.6789 32.156 19.6789C32.156 19.6789 31.0489 21.5131 29.1587 24.259C29.1587 24.259 30.9601 19.471 33.2657 16.3039C33.2657 16.3039 32.8626 15.4183 31.8515 15.1366C31.8515 15.1366 28.0649 18.8014 25.321 23.5804C25.321 23.5804 26.2459 21.0325 28.5489 17.6017C28.5489 17.6017 28.1361 16.7206 27.1329 16.4299C27.1329 16.4299 24.9303 18.463 22.1759 22.5202C22.1759 22.5202 23.1571 20.5897 24.1981 18.8797C24.1981 18.8797 23.6763 17.9221 22.7752 17.7052C22.7752 17.7052 22.2085 18.3406 21.1551 20.5852C21.1551 20.5852 19.1179 23.386 17.5999 25.0492C17.5999 25.0492 18.0056 22.7452 21.1322 17.6719C21.1322 17.6719 20.7494 16.8079 19.7093 16.5046C19.7093 16.5046 16.822 19.8931 14.006 24.1735C14.006 24.1735 15.4527 20.3287 17.3473 17.3326C17.3473 17.3326 16.7542 16.3138 15.9323 16.1608C15.9323 16.1608 14.1001 18.4279 12.3313 21.0217C11.989 19.12 10.3557 17.6737 8.39862 17.6737C6.19334 17.6737 4.3999 19.5088 4.3999 21.7633C4.3999 24.0178 6.19334 25.8529 8.39862 25.8529C9.85238 25.8529 11.1275 25.0546 11.8271 23.8657C12.2011 23.2789 13.177 21.748 13.6575 20.992C12.8101 22.8694 12.0656 24.7675 11.1284 27.4045C11.1284 27.4045 11.5886 28.3252 12.5355 28.5745C12.5355 28.5745 15.8443 23.0917 17.4309 21.4582C17.4309 21.4582 16.5923 23.2411 15.8346 25.7044C15.8346 25.7044 16.2553 26.6143 17.24 26.8816C17.24 26.8816 18.4262 25.7863 20.0657 23.503L18.4825 27.6943C18.4825 27.6943 19.0132 28.6942 19.8773 28.8643C19.8773 28.8643 23.2222 22.4239 25.4257 19.9687C25.4257 19.9687 23.7819 23.5867 23.3463 25.4938C23.3463 25.4938 23.6341 26.3029 24.7622 26.6692C24.7622 26.6692 27.6213 21.6751 29.8037 19.3378C29.8037 19.3378 27.785 23.3932 27.2834 25.3579C27.2834 25.3579 27.6205 26.2093 28.6888 26.5486C28.6888 26.5486 29.8125 25.2283 31.6614 22.4743C31.9905 24.3922 33.6309 25.8547 35.5994 25.8547C37.8047 25.8547 39.5981 24.0205 39.5981 21.7651C39.5999 19.5088 37.8065 17.6737 35.6012 17.6737ZM8.39862 24.2707C7.04694 24.2707 5.94694 23.1466 5.94694 21.7633C5.94694 20.3809 7.04694 19.2559 8.39862 19.2559C9.7503 19.2559 10.8503 20.3809 10.8503 21.7633C10.8503 23.1466 9.7503 24.2707 8.39862 24.2707ZM35.6012 24.2707C34.2495 24.2707 33.1495 23.1466 33.1495 21.7633C33.1495 20.3809 34.2495 19.2559 35.6012 19.2559C36.9529 19.2559 38.0529 20.3809 38.0529 21.7633C38.0529 23.1466 36.9529 24.2707 35.6012 24.2707Z",
  fill: "#222222"
});

var SvgOnmobile = function SvgOnmobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnmobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Onmobile.376413fb.svg";
export { ForwardRef as ReactComponent };